"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForgotPasswordResetMutation = exports.useForgotPasswordMutation = exports.useResetPasswordMutation = exports.useLoginMutation = exports.authApi = void 0;
// api/authApi.ts
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.authApi = (0, react_1.createApi)({
    reducerPath: "authApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["auth"],
    endpoints: function (builder) { return ({
        login: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/user/login",
                method: "POST",
                body: obj,
            }); },
            invalidatesTags: ["auth"],
        }),
        resetPassword: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/user/reset-password",
                method: "POST",
                body: obj,
            }); },
        }),
        forgotPassword: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/user/forgot-password",
                method: "POST",
                body: obj,
            }); },
        }),
        forgotPasswordReset: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/user/forgot-password/reset",
                method: "POST",
                body: obj,
            }); },
        }),
    }); },
});
exports.useLoginMutation = exports.authApi.useLoginMutation, exports.useResetPasswordMutation = exports.authApi.useResetPasswordMutation, exports.useForgotPasswordMutation = exports.authApi.useForgotPasswordMutation, exports.useForgotPasswordResetMutation = exports.authApi.useForgotPasswordResetMutation;
